module.exports = __webpack_public_path__ + "static/media/khaleeq.e68b3bd2.jpg";